import axios from "axios";

const RAW_BASE =
  import.meta.env.VITE_URL ||
  import.meta.env.VITE_URL2 ||
  "http://localhost:3000";
const BASE = String(RAW_BASE).replace(/\/api\/?$/i, "");
export const PASSENGER_API_BASE = `${BASE}/api/passengers`;

const withCreds = { withCredentials: true };

export const passengerAdminApi = {
  /**
   * 7. Admin — Saare Passengers (Sabhi Users Ke) Dekhna
   * GET /api/passengers/admin
   */
  getAllPassengers: async () => {
    const response = await axios.get(`${PASSENGER_API_BASE}/admin`, withCreds);
    return response.data;
  },

  /**
   * 8. Admin — Ek Specific User Ke Saare Passengers
   * GET /api/passengers/admin/user/:userId
   */
  getPassengersByUser: async (userId) => {
    const response = await axios.get(
      `${PASSENGER_API_BASE}/admin/user/${userId}`,
      withCreds,
    );
    return response.data;
  },

  /**
   * 9. Admin — Ek Passenger Id Se Dekhna
   * GET /api/passengers/admin/:id
   */
  getPassengerById: async (id) => {
    const response = await axios.get(
      `${PASSENGER_API_BASE}/admin/${id}`,
      withCreds,
    );
    return response.data;
  },

  /**
   * 6. Admin — Kisi Bhi User Ke Liye Passenger Create Karna
   * POST /api/passengers/admin
   * payload must include: userId, title, firstName, lastName, gender, dateOfBirth, passengerType, etc.
   */
  createPassenger: async (payload) => {
    const response = await axios.post(
      `${PASSENGER_API_BASE}/admin`,
      payload,
      withCreds,
    );
    return response.data;
  },

  /**
   * 10. Admin — Kisi Bhi Passenger Ko Update Karna
   * PUT /api/passengers/admin/:id
   */
  updatePassenger: async (id, payload) => {
    const response = await axios.put(
      `${PASSENGER_API_BASE}/admin/${id}`,
      payload,
      withCreds,
    );
    return response.data;
  },

  /**
   * 11. Admin — Kisi Bhi Passenger Ko Delete Karna
   * DELETE /api/passengers/admin/:id
   */
  deletePassenger: async (id) => {
    const response = await axios.delete(
      `${PASSENGER_API_BASE}/admin/${id}`,
      withCreds,
    );
    return response.data;
  },
};

export default passengerAdminApi;
